import React, { FC } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { PERMISSION_NAMES, isSupplierAllowedToAccess } from '../../utils/AuthUtils';
import { SUPPLIER_TECH } from '../roles/roles';

export const canFieldManageStockLocation = (currentUser, stockLocation, companyConfig) => {
	const roles = nullSafeGetOrElse('roles', currentUser, []);
	const isFieldTech = roles.some((role) => role === SUPPLIER_TECH);

	// Field-tech assignment fallback — ONLY for field techs. A tech assigned to this stock
	// location (or to all) may manage it regardless of the role-level permission. Non-tech
	// roles must NOT ride this list; their access is governed solely by the role permission.
	const email = nullSafeGetOrElse('email', currentUser, '').trim().toLowerCase();
	const allEmails = nullSafeGetOrElse('canManageFieldTechEmailsString', stockLocation, '')
		.split(',')
		.map((entry) => entry.trim().toLowerCase())
		.filter((entry) => !!entry);
	const fieldTechManagesThisSL =
		isFieldTech &&
		(nullSafeGetOrElse('canManageAllStockLocations', currentUser, false) ||
			allEmails.includes(email));

	// Everyone else's access is governed by the "Manage Stock Locations" role permission.
	// isSupplierAllowedToAccess already grants admins the override.
	const roleAllowed = isSupplierAllowedToAccess(
		PERMISSION_NAMES.MANAGE_STOCK_LOCATIONS,
		companyConfig,
		roles
	);

	return fieldTechManagesThisSL || roleAllowed;
};

const FeildTechSLManagePermissionChecker: FC<any> = ({
	stockLocation,
	currentUser,
	companyConfig,
	children,
}): React.ReactElement => {
	return canFieldManageStockLocation(currentUser, stockLocation, companyConfig) ? children : null;
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	// Resolve the stock location by the route id rather than the shared
	// state.stock_locations.detail slot, which can briefly hold a different location.
	stockLocation: getEntityById(nullSafeGet('match.params.id', ownProps), state.stock_locations),
	companyConfig: state.company_config.detail,
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps)(FeildTechSLManagePermissionChecker)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
